// 注册插件：
// import LoginPanel from "@tencent/vft-component/LoginPanel";
// Vue.use(LoginPanel, { pageUrl: 'https://film.qq.com' })
// 说明： pageUrl 是可选参数，默认是当前页面地址

// 使用方法：
// 1. 调用双登录组件
// this.$openLogin({
//     jumpUrl: location.href,
//     // 可选：支持 app 下监听登录回调，便于异步刷新页面
//     onLogin: () => {
//         alert('登录成功')
//     }
// })
// 2. 直接拉起指定登录
// this.$switchLogin({
//     type: 'qq',
//     jumpUrl: location.href,
//     // 可选：支持 app 下监听登录回调，便于异步刷新页面
//     onLogin: () => {
//         alert('登录成功')
//     }
// })
// 说明：
// 也可以全局注册 window.reinit 的方法，用于登录成功后，统一调用该方法刷新页面数据

import LoginPanel from './LoginPanel.vue';

export default {
  install(Vue, option) {
    const $el = document.createElement('div');
    document.body.appendChild($el);

    const VueComponent = Vue.extend(LoginPanel);
    const instance = new VueComponent();
    instance.$mount($el);
    LoginPanel.install(Vue, option);
  },
};
